import { render, staticRenderFns } from "./LineItem1.vue?vue&type=template&id=248c6563&scoped=true&"
import script from "./LineItem1.vue?vue&type=script&lang=js&"
export * from "./LineItem1.vue?vue&type=script&lang=js&"
import style0 from "./LineItem1.vue?vue&type=style&index=0&id=248c6563&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c6563",
  null
  
)

export default component.exports